import { memo } from 'react';
import { Pressable } from 'react-native';
import Box from '../Box/Box';
import { PaginationProps } from './Pagination.types';

const Pagination = ({ data, activeIndex, onPress, ...rest }: PaginationProps) => {
  return (
    <Box
      gap="space-200"
      padding="space-200"
      alignSelf="center"
      flexDirection="row"
      borderRadius="radius-full"
      backgroundColor="screenBackground"
      opacity={0.7}
      {...rest}
    >
      {data.map((_, index) => {
        return (
          <Pressable key={index} onPress={() => onPress(index)}>
            <Box
              backgroundColor="whiteBackground"
              width={8}
              height={8}
              borderRadius="radius-full"
              opacity={activeIndex === index ? 1 : 0.5}
            />
          </Pressable>
        );
      })}
    </Box>
  );
};

export default memo(Pagination);
